/**
 * Data translation of astro_calculations/astrology/static_astrology_config.yaml —
 * ONLY the sections static_predictions.py reads (rulerships, transit_weights,
 * dasha_influences, profection_emphasis, house_influences, event_detection,
 * metrics, divisional_metrics). tooltips / colors / global are display-only and
 * never reach the scoring closure, so they are not carried over.
 *
 * GENERATED from the YAML via yaml.safe_load + json.dumps (full float precision);
 * integer YAML keys (sign numbers, house numbers) become string keys here — JS
 * object indexing with numbers coerces to string, so lookups port 1:1.
 * Do not hand-edit values; regenerate from the YAML if it changes.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const STATIC_ASTRO_CONFIG: any = {
  "rulerships": {
    "0": "mars",
    "1": "venus",
    "2": "mercury",
    "3": "moon",
    "4": "sun",
    "5": "mercury",
    "6": "venus",
    "7": "mars",
    "8": "jupiter",
    "9": "saturn",
    "10": "saturn",
    "11": "jupiter"
  },
  "transit_weights": {
    "planet_base": {
      "moon": 0.5,
      "sun": 0.7,
      "mercury": 0.8,
      "venus": 0.9,
      "mars": 1.0,
      "jupiter": 1.5,
      "saturn": 2.0,
      "rahu": 1.8,
      "ketu": 1.8,
      "uranus": 2.5,
      "neptune": 2.8,
      "pluto": 3.0,
      "chiron": 1.5
    },
    "multipliers": {
      "retrograde": 1.15,
      "stationing": 1.3
    }
  },
  "dasha_influences": {
    "d1_offsets": {
      "ketu": {
        "D1_Spiritual": 1.5,
        "D1_Transformation": 0.8
      },
      "venus": {
        "D1_Relationships": 1.8,
        "D1_Finance": 1.2,
        "D1_Mood": 0.8
      },
      "sun": {
        "D1_Confidence": 1.5,
        "D1_Career": 1.0,
        "D1_Health": 0.7
      },
      "moon": {
        "D1_Mood": 1.8,
        "D1_Health": 0.7,
        "D1_Relationships": 0.8
      },
      "mars": {
        "D1_Drive": 1.8,
        "D1_Conflict": -0.8,
        "D1_Health": 0.5
      },
      "rahu": {
        "D1_InnovationEvents": 1.5,
        "D1_Transformation": 1.0,
        "D1_Career": 0.7
      },
      "jupiter": {
        "D1_Confidence": 1.5,
        "D1_Finance": 1.2,
        "D1_Spiritual": 1.2,
        "D1_LearningIdeas": 0.8
      },
      "saturn": {
        "D1_Career": 0.8,
        "D1_Transformation": 0.7
      },
      "mercury": {
        "D1_Communication": 1.8,
        "D1_LearningIdeas": 1.5,
        "D1_Finance": 0.7
      }
    },
    "divisional_offsets": {
      "venus": {
        "D2_Wealth": 1.0,
        "D9_Relationships": 1.5,
        "D16_Vehicles": 0.8,
        "D4_Fortune": 0.7
      },
      "jupiter": {
        "D2_Wealth": 1.5,
        "D10_Career": 0.8,
        "D20_Spiritual": 1.2,
        "D24_Education": 1.0,
        "D5_Authority": 0.7
      },
      "saturn": {
        "D10_Career": 1.0,
        "D30_Difficulties": -0.7,
        "D8_Longevity": 0.5,
        "D60_Karma": 0.8
      },
      "sun": {
        "D10_Career": 1.2,
        "D5_Authority": 1.0,
        "D27_Strength": 0.7
      },
      "moon": {
        "D4_Fortune": 0.8,
        "D9_Relationships": 0.6,
        "D12_Parents": 0.5
      },
      "mars": {
        "D10_Career": 0.7,
        "D3_Siblings": 0.8,
        "D27_Strength": 0.9,
        "D8_Longevity": -0.5
      },
      "rahu": {
        "D10_Career": 0.8,
        "D40_Effects": 0.7,
        "D60_Karma": 1.0
      },
      "ketu": {
        "D20_Spiritual": 1.2,
        "D60_Karma": 1.0,
        "D30_Difficulties": -0.6
      },
      "mercury": {
        "D2_Wealth": 0.7,
        "D24_Education": 1.2,
        "D3_Siblings": 0.6
      }
    },
    "antardasha_multiplier": 0.5
  },
  "profection_emphasis": {
    "d1_boosts": {
      "1": {
        "D1_Health": 1.3,
        "D1_Confidence": 1.2
      },
      "2": {
        "D1_Finance": 1.3
      },
      "3": {
        "D1_Communication": 1.3,
        "D1_LearningIdeas": 1.2
      },
      "4": {
        "D1_Mood": 1.2
      },
      "5": {
        "D1_Drive": 1.2,
        "D1_InnovationEvents": 1.2
      },
      "6": {
        "D1_Health": 1.2
      },
      "7": {
        "D1_Relationships": 1.4
      },
      "8": {
        "D1_Transformation": 1.3,
        "D1_Finance": 1.2
      },
      "9": {
        "D1_Spiritual": 1.3,
        "D1_LearningIdeas": 1.2
      },
      "10": {
        "D1_Career": 1.4
      },
      "11": {
        "D1_Finance": 1.2,
        "D1_InnovationEvents": 1.2
      },
      "12": {
        "D1_Spiritual": 1.3,
        "D1_Transformation": 1.2
      }
    },
    "divisional_boosts": {
      "2": {
        "D2_Wealth": 1.2,
        "D4_Fortune": 1.1
      },
      "3": {
        "D3_Siblings": 1.2
      },
      "4": {
        "D4_Fortune": 1.3,
        "D12_Parents": 1.1
      },
      "5": {
        "D5_Authority": 1.2,
        "D7_Children": 1.1
      },
      "6": {
        "D30_Difficulties": 1.2,
        "D8_Longevity": 1.1
      },
      "7": {
        "D9_Relationships": 1.3,
        "D7_Children": 1.1
      },
      "8": {
        "D8_Longevity": 1.2,
        "D30_Difficulties": 1.1
      },
      "9": {
        "D20_Spiritual": 1.3,
        "D24_Education": 1.2
      },
      "10": {
        "D10_Career": 1.3,
        "D5_Authority": 1.1
      },
      "11": {
        "D2_Wealth": 1.2,
        "D4_Fortune": 1.1
      },
      "12": {
        "D20_Spiritual": 1.2,
        "D60_Karma": 1.1
      }
    }
  },
  "house_influences": {
    "d1_weights": {
      "1": {
        "D1_Health": 1.2,
        "D1_Confidence": 1.2
      },
      "2": {
        "D1_Finance": 1.3
      },
      "4": {
        "D1_Mood": 1.2
      },
      "7": {
        "D1_Relationships": 1.3
      },
      "10": {
        "D1_Career": 1.3
      },
      "11": {
        "D1_Finance": 1.2
      },
      "12": {
        "D1_Spiritual": 1.2,
        "D1_Transformation": 1.2
      }
    },
    "divisional_weights": {
      "1": {
        "D5_Authority": 1.2,
        "D27_Strength": 1.1
      },
      "2": {
        "D2_Wealth": 1.2,
        "D4_Fortune": 1.1
      },
      "3": {
        "D3_Siblings": 1.3,
        "D24_Education": 1.1
      },
      "4": {
        "D4_Fortune": 1.2,
        "D12_Parents": 1.2
      },
      "5": {
        "D7_Children": 1.3,
        "D5_Authority": 1.1
      },
      "6": {
        "D30_Difficulties": 1.2,
        "D8_Longevity": 1.1
      },
      "7": {
        "D9_Relationships": 1.3
      },
      "8": {
        "D8_Longevity": 1.2,
        "D60_Karma": 1.1
      },
      "9": {
        "D20_Spiritual": 1.3,
        "D24_Education": 1.2
      },
      "10": {
        "D10_Career": 1.3,
        "D5_Authority": 1.2
      },
      "11": {
        "D2_Wealth": 1.2,
        "D40_Effects": 1.1
      },
      "12": {
        "D20_Spiritual": 1.2,
        "D60_Karma": 1.2,
        "D30_Difficulties": 1.1
      }
    },
    "strength_modifier_range": 0.3
  },
  "event_detection": {
    "career": {
      "breakthrough": {
        "D1_Career": 3.5,
        "D10_Career": 3.0,
        "D1_Confidence": 2.5
      },
      "peak": {
        "D1_Career": 3.0,
        "D10_Career": 2.5,
        "D1_Confidence": 2.0
      },
      "crisis": {
        "D1_Career": -3.5,
        "D10_Career": -3.0
      },
      "challenge": {
        "D1_Career": -3.0,
        "D10_Career": -2.5
      }
    },
    "relationships": {
      "breakthrough": {
        "D1_Relationships": 3.5,
        "D9_Relationships": 3.0
      },
      "opportunity": {
        "D1_Relationships": 3.0,
        "D9_Relationships": 2.5,
        "D1_Mood": 1.5
      },
      "crisis": {
        "D1_Relationships": -3.5,
        "D9_Relationships": -3.0
      },
      "tension": {
        "D1_Relationships": -3.0,
        "D9_Relationships": -2.5,
        "D1_Conflict": -2.5
      }
    },
    "finance": {
      "major_opportunity": {
        "D1_Finance": 3.5,
        "D2_Wealth": 3.0
      },
      "opportunity": {
        "D1_Finance": 2.5,
        "D2_Wealth": 2.0,
        "D4_Fortune": 2.0
      },
      "caution": {
        "D1_Finance": -3.0,
        "D2_Wealth": -2.5
      }
    },
    "transformation": {
      "major_positive": {
        "D1_Transformation": 3.5
      },
      "major_challenging": {
        "D1_Transformation": -3.5
      },
      "spiritual": {
        "D1_Transformation_abs": 3.0,
        "D1_Spiritual_abs": 2.5
      }
    },
    "health": {
      "serious_caution": {
        "D1_Health": -3.5,
        "D30_Difficulties": -3.0
      },
      "caution": {
        "D1_Health": -3.0,
        "D30_Difficulties": -2.5,
        "D8_Longevity": -2.5
      },
      "vitality_peak": {
        "D1_Health": 3.5,
        "D27_Strength": 2.5
      }
    },
    "education": {
      "major_opportunity": {
        "D1_LearningIdeas": 3.5,
        "D24_Education": 3.0
      },
      "breakthrough": {
        "D1_LearningIdeas": 3.0,
        "D24_Education": 2.5
      }
    },
    "creativity": {
      "peak": {
        "D7_Children": 3.5
      }
    },
    "leadership": {
      "recognition": {
        "D1_Career": 3.0,
        "D5_Authority": 3.0
      }
    },
    "innovation": {
      "major": {
        "D1_InnovationEvents": 3.5,
        "D1_LearningIdeas": 3.0
      },
      "breakthrough": {
        "D1_InnovationEvents": 3.0,
        "D1_LearningIdeas": 2.5
      }
    },
    "learning": {
      "expansion": {
        "D1_LearningIdeas": 3.0,
        "D1_Communication": 2.5
      }
    },
    "spiritual": {
      "awakening": {
        "D1_Spiritual": 3.5,
        "D20_Spiritual": 3.0
      },
      "growth": {
        "D1_Spiritual": 3.0,
        "D20_Spiritual": 2.5
      }
    },
    "karma": {
      "major_event": {
        "D60_Karma_abs": 3.5
      }
    },
    "life_events": {
      "intense_threshold": 3.5,
      "major_pivot_count": 6,
      "crossroads_count": 5,
      "extremely_fortunate_count": 4,
      "highly_challenging_count": 4
    },
    "dasha_events": {
      "saturn_maturation": {
        "dasha": "saturn",
        "D1_Transformation": -2.5
      },
      "rahu_disruption": {
        "dasha": "rahu",
        "D1_Transformation_abs": 3.0
      },
      "jupiter_expansion": {
        "dasha": "jupiter",
        "D1_Confidence": 3.0
      }
    },
    "mutual_reception_bonus": 1.15
  },
  "metrics": {
    "Health": {
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "sun",
            "ascendant",
            "mars"
          ]
        },
        {
          "transit": "mars",
          "targets": [
            "sun",
            "ascendant"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "sun",
            "ascendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 1.1,
            "hard": -0.8,
            "conj": 0.7
          }
        },
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 0.9,
            "hard": -1.2,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": 0.3,
            "hard": -1.3,
            "conj": -1.0
          }
        }
      ]
    },
    "Mood": {
      "pairs": [
        {
          "transit": "moon",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "venus",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "neptune",
          "targets": [
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "moon"
          },
          "weights": {
            "soft": 1.1,
            "hard": -1.1,
            "conj": 0.4
          }
        },
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.8,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "neptune"
          },
          "weights": {
            "soft": 0.8,
            "hard": -1.2,
            "conj": 0.5
          }
        }
      ]
    },
    "Confidence": {
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "jupiter"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "sun",
            "ascendant"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "sun"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "sun",
            "target": "jupiter"
          },
          "weights": {
            "soft": 1.1,
            "hard": 0.2,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "jupiter",
            "target_in": [
              "sun",
              "ascendant"
            ]
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.4,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "saturn",
            "target": "sun"
          },
          "weights": {
            "soft": 0.3,
            "hard": -1.1,
            "conj": -0.7
          }
        }
      ]
    },
    "Relationships": {
      "pairs": [
        {
          "transit": "venus",
          "targets": [
            "venus",
            "moon",
            "descendant"
          ]
        },
        {
          "transit": "rahu",
          "targets": [
            "venus",
            "descendant"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "venus",
            "descendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 1.1,
            "hard": -0.9,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit_in": [
              "rahu",
              "ketu"
            ],
            "target_in": [
              "venus",
              "descendant"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": 0.5,
            "hard": 0.5,
            "conj": 0.5
          }
        }
      ]
    },
    "Drive": {
      "pairs": [
        {
          "transit": "mars",
          "targets": [
            "sun",
            "ascendant",
            "mars"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 1.0,
            "hard": -1.1,
            "conj": 1.2
          }
        }
      ]
    },
    "Conflict": {
      "pairs": [
        {
          "transit": "mars",
          "targets": [
            "moon",
            "venus"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "mars"
          ]
        },
        {
          "transit": "pluto",
          "targets": [
            "mars"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mars",
            "target_in": [
              "moon",
              "venus"
            ]
          },
          "weights": {
            "soft": -0.3,
            "hard": -1.3,
            "conj": -0.6
          }
        },
        {
          "when": {
            "transit": "saturn",
            "target": "mars"
          },
          "weights": {
            "soft": -0.3,
            "hard": -1.1,
            "conj": -0.3
          }
        },
        {
          "when": {
            "transit": "pluto",
            "target": "mars"
          },
          "weights": {
            "soft": -0.4,
            "hard": -1.3,
            "conj": -0.4
          }
        }
      ]
    },
    "Career": {
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "midheaven"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "midheaven"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "midheaven"
          ]
        },
        {
          "transit": "pluto",
          "targets": [
            "midheaven"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit_in": [
              "sun",
              "jupiter"
            ],
            "target": "midheaven"
          },
          "weights": {
            "soft": 1.1,
            "hard": 0.3,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "saturn",
            "target": "midheaven"
          },
          "weights": {
            "soft": 0.5,
            "hard": -0.2,
            "conj": 0.3
          }
        },
        {
          "when": {
            "transit": "pluto",
            "target": "midheaven"
          },
          "weights": {
            "soft": 0.6,
            "hard": -0.9,
            "conj": 0.7
          }
        }
      ]
    },
    "Finance": {
      "pairs": [
        {
          "transit": "venus",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "pluto",
          "targets": [
            "venus"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "venus",
            "target": "venus"
          },
          "weights": {
            "soft": 1.1,
            "hard": -0.7,
            "conj": 0.8
          }
        },
        {
          "when": {
            "transit": "jupiter",
            "target": "venus"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.2,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit_in": [
              "saturn",
              "pluto"
            ],
            "target": "venus"
          },
          "weights": {
            "soft": -0.3,
            "hard": -1.1,
            "conj": -0.3
          }
        }
      ]
    },
    "LearningIdeas": {
      "pairs": [
        {
          "transit": "mercury",
          "targets": [
            "mercury"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "mercury"
          ]
        },
        {
          "transit": "uranus",
          "targets": [
            "mercury"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mercury",
            "target": "mercury"
          },
          "weights": {
            "soft": 1.0,
            "hard": -0.7,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit_in": [
              "jupiter",
              "uranus"
            ],
            "target": "mercury"
          },
          "weights": {
            "soft": 1.2,
            "hard": -0.3,
            "conj": 1.1
          }
        }
      ]
    },
    "Communication": {
      "pairs": [
        {
          "transit": "mercury",
          "targets": [
            "mercury",
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mercury",
            "target_in": [
              "mercury",
              "moon"
            ]
          },
          "weights": {
            "soft": 1.0,
            "hard": -0.9,
            "conj": 0.9
          }
        }
      ]
    },
    "Transformation": {
      "pairs": [
        {
          "transit": "pluto",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        },
        {
          "transit": "rahu",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        },
        {
          "transit": "chiron",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit_in": [
              "pluto",
              "saturn"
            ],
            "target_in": [
              "sun",
              "moon",
              "ascendant"
            ]
          },
          "weights": {
            "soft": 0.4,
            "hard": -1.2,
            "conj": -1.0
          }
        },
        {
          "when": {
            "transit_in": [
              "rahu",
              "ketu"
            ],
            "target_in": [
              "sun",
              "moon",
              "ascendant"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": 0.6,
            "hard": 0.6,
            "conj": 0.6
          }
        },
        {
          "when": {
            "transit": "chiron",
            "target_in": [
              "sun",
              "moon",
              "ascendant"
            ]
          },
          "weights": {
            "soft": 0.7,
            "hard": -0.7,
            "conj": 0.5
          }
        }
      ]
    },
    "Spiritual": {
      "pairs": [
        {
          "transit": "neptune",
          "targets": [
            "sun",
            "moon",
            "jupiter"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "ascendant",
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "neptune",
            "target_in": [
              "sun",
              "moon"
            ]
          },
          "weights": {
            "soft": 1.1,
            "hard": -0.9,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "jupiter",
            "target": "neptune"
          },
          "weights": {
            "soft": 1.0,
            "hard": 0.1,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit": "ketu",
            "target_in": [
              "ascendant",
              "moon"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": 0.5,
            "hard": 0.5,
            "conj": 0.5
          }
        }
      ]
    },
    "InnovationEvents": {
      "pairs": [
        {
          "transit": "uranus",
          "targets": [
            "sun",
            "mercury",
            "ascendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "uranus",
            "target_in": [
              "sun",
              "mercury",
              "ascendant"
            ]
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.4,
            "conj": 1.1,
            "opp": 1.1
          }
        }
      ]
    }
  },
  "divisional_metrics": {
    "D2_Wealth": {
      "division": 2,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "venus",
            "moon",
            "sun"
          ]
        },
        {
          "transit": "venus",
          "targets": [
            "jupiter",
            "venus"
          ]
        },
        {
          "transit": "sun",
          "targets": [
            "jupiter",
            "sun"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.2,
            "conj": 1.3
          }
        },
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.6,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.1,
            "conj": 0.8
          }
        }
      ]
    },
    "D3_Siblings": {
      "division": 3,
      "pairs": [
        {
          "transit": "mars",
          "targets": [
            "mars",
            "mercury"
          ]
        },
        {
          "transit": "mercury",
          "targets": [
            "mars",
            "mercury"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.6,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "mercury"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.4,
            "conj": 0.8
          }
        }
      ]
    },
    "D4_Fortune": {
      "division": 4,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "moon",
            "venus",
            "jupiter"
          ]
        },
        {
          "transit": "venus",
          "targets": [
            "moon",
            "venus"
          ]
        },
        {
          "transit": "moon",
          "targets": [
            "jupiter",
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": -0.2,
            "conj": 1.2
          }
        },
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.4,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "moon"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.3,
            "conj": 0.8
          }
        }
      ]
    },
    "D5_Authority": {
      "division": 5,
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "sun",
            "jupiter"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "sun"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "sun"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 1.0,
            "hard": 0.2,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.1,
            "hard": 0.3,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": 0.4,
            "hard": -0.7,
            "conj": 0.3
          }
        }
      ]
    },
    "D7_Children": {
      "division": 7,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "jupiter",
            "venus",
            "moon"
          ]
        },
        {
          "transit": "venus",
          "targets": [
            "jupiter"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.2,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.3,
            "conj": 0.8
          }
        }
      ]
    },
    "D8_Longevity": {
      "division": 8,
      "pairs": [
        {
          "transit": "saturn",
          "targets": [
            "sun",
            "moon",
            "ascendant"
          ]
        },
        {
          "transit": "mars",
          "targets": [
            "sun",
            "ascendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": -0.5,
            "hard": -1.2,
            "conj": -0.8
          }
        },
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": -0.4,
            "hard": -0.9,
            "conj": -0.5
          }
        }
      ]
    },
    "D9_Relationships": {
      "division": 9,
      "pairs": [
        {
          "transit": "venus",
          "targets": [
            "venus",
            "moon"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "moon",
          "targets": [
            "venus",
            "moon"
          ]
        },
        {
          "transit": "mars",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "rahu",
          "targets": [
            "venus"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "venus"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 1.2,
            "hard": -0.8,
            "conj": 1.2
          }
        },
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.0,
            "hard": 0.3,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "moon"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.4,
            "conj": 0.8
          }
        },
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 0.2,
            "hard": -0.7,
            "conj": -0.3
          }
        },
        {
          "when": {
            "transit_in": [
              "rahu",
              "ketu"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": 0.6,
            "hard": 0.6,
            "conj": 0.6
          }
        }
      ]
    },
    "D10_Career": {
      "division": 10,
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "sun",
            "midheaven"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "midheaven",
            "sun"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "midheaven",
            "sun",
            "saturn"
          ]
        },
        {
          "transit": "mars",
          "targets": [
            "midheaven",
            "mars"
          ]
        },
        {
          "transit": "mercury",
          "targets": [
            "midheaven",
            "mercury"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 1.0,
            "hard": 0.2,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.4,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "saturn",
            "target": "midheaven"
          },
          "weights": {
            "soft": 0.3,
            "hard": -0.8,
            "conj": 0.4
          }
        },
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": 0.3,
            "hard": -0.8,
            "conj": 0.3
          }
        },
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 0.7,
            "hard": -0.5,
            "conj": 0.7
          }
        },
        {
          "when": {
            "transit": "mercury"
          },
          "weights": {
            "soft": 0.6,
            "hard": -0.3,
            "conj": 0.6
          }
        }
      ]
    },
    "D12_Parents": {
      "division": 12,
      "pairs": [
        {
          "transit": "sun",
          "targets": [
            "sun"
          ]
        },
        {
          "transit": "moon",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "sun",
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.3,
            "conj": 0.7
          }
        },
        {
          "when": {
            "transit": "moon"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.3,
            "conj": 0.7
          }
        },
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": -0.4,
            "hard": -0.9,
            "conj": -0.5
          }
        }
      ]
    },
    "D16_Vehicles": {
      "division": 16,
      "pairs": [
        {
          "transit": "venus",
          "targets": [
            "venus",
            "moon"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "venus"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 1.0,
            "hard": -0.5,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.1,
            "hard": 0.2,
            "conj": 1.0
          }
        }
      ]
    },
    "D20_Spiritual": {
      "division": 20,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "jupiter",
            "moon"
          ]
        },
        {
          "transit": "neptune",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.2,
            "conj": 1.1
          }
        },
        {
          "when": {
            "transit": "neptune"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.6,
            "conj": 0.8
          }
        },
        {
          "when": {
            "transit": "ketu",
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": 0.7,
            "hard": 0.7,
            "conj": 0.7
          }
        }
      ]
    },
    "D24_Education": {
      "division": 24,
      "pairs": [
        {
          "transit": "mercury",
          "targets": [
            "mercury",
            "jupiter"
          ]
        },
        {
          "transit": "jupiter",
          "targets": [
            "mercury"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mercury"
          },
          "weights": {
            "soft": 1.0,
            "hard": -0.5,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.2,
            "hard": 0.3,
            "conj": 1.1
          }
        }
      ]
    },
    "D27_Strength": {
      "division": 27,
      "pairs": [
        {
          "transit": "mars",
          "targets": [
            "mars",
            "sun"
          ]
        },
        {
          "transit": "sun",
          "targets": [
            "mars"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": 0.9,
            "hard": -0.7,
            "conj": 1.0
          }
        },
        {
          "when": {
            "transit": "sun"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.3,
            "conj": 0.7
          }
        }
      ]
    },
    "D30_Difficulties": {
      "division": 30,
      "pairs": [
        {
          "transit": "saturn",
          "targets": [
            "moon",
            "sun"
          ]
        },
        {
          "transit": "mars",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "rahu",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "pluto",
          "targets": [
            "sun",
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": -0.6,
            "hard": -1.3,
            "conj": -0.9
          }
        },
        {
          "when": {
            "transit": "mars"
          },
          "weights": {
            "soft": -0.7,
            "hard": -1.1,
            "conj": -0.7
          }
        },
        {
          "when": {
            "transit_in": [
              "rahu",
              "ketu"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": -0.9,
            "hard": -0.9,
            "conj": -0.9
          }
        },
        {
          "when": {
            "transit": "pluto"
          },
          "weights": {
            "soft": -0.5,
            "hard": -1.0,
            "conj": -0.5
          }
        }
      ]
    },
    "D40_Effects": {
      "division": 40,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "jupiter",
            "venus"
          ]
        },
        {
          "transit": "saturn",
          "targets": [
            "saturn"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 0.9,
            "hard": 0.1,
            "conj": 0.8
          }
        },
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": -0.4,
            "hard": -0.8,
            "conj": -0.5
          }
        }
      ]
    },
    "D45_Wellbeing": {
      "division": 45,
      "pairs": [
        {
          "transit": "jupiter",
          "targets": [
            "ascendant",
            "moon"
          ]
        },
        {
          "transit": "venus",
          "targets": [
            "ascendant"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "jupiter"
          },
          "weights": {
            "soft": 1.0,
            "hard": 0.2,
            "conj": 0.9
          }
        },
        {
          "when": {
            "transit": "venus"
          },
          "weights": {
            "soft": 0.8,
            "hard": -0.3,
            "conj": 0.7
          }
        }
      ]
    },
    "D60_Karma": {
      "division": 60,
      "pairs": [
        {
          "transit": "saturn",
          "targets": [
            "saturn",
            "moon"
          ]
        },
        {
          "transit": "rahu",
          "targets": [
            "moon"
          ]
        },
        {
          "transit": "ketu",
          "targets": [
            "moon"
          ]
        }
      ],
      "rules": [
        {
          "when": {
            "transit": "saturn"
          },
          "weights": {
            "soft": -0.5,
            "hard": -1.0,
            "conj": -0.7
          }
        },
        {
          "when": {
            "transit_in": [
              "rahu",
              "ketu"
            ],
            "drishti_in": [
              0,
              7
            ]
          },
          "weights": {
            "soft": -0.6,
            "hard": -0.6,
            "conj": -0.6
          }
        }
      ]
    }
  }
};
